module.exports = __webpack_public_path__ + "static/media/talent_profile_modal_back_small-min.54a1029f.png";